import React from "react";
import { Layout, Row, Col, Card } from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../store/actions/auth";
import Login from "./Login";

const { Footer } = Layout;
class UserLayout extends React.Component {
  render() {
    return (
      <Layout>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ height: "90vh" }}
        >
          <Col>
            <Card
              title="Đăng nhập"
              bordered={false}
              hoverable={false}
              style={{ boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" }}
            >
              <Login />
            </Card>
          </Col>
        </Row>
        <Footer style={{ textAlign: "center", height: "10vh" }}>
          RAINSCALES ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.token !== null,
    // loading: state.cart.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserLayout),
);
